export default {
    name: "Expense Access",
    meta: {
        icon: "account_balance_wallet",
        expanded: true,
        auth: true
    },

    departmentName: "Expense Access",
    finalPagePermision: "Expense Approval Request",

    children: [
        {
            name: "Expense Approval Request",
            path: "/payment/approval",
            permissionName: 'Expense Approval Request',
            keywords: ['Expense Approval Request', 'Expense Access'],
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/payment/PaymentApprovalList.vue"),
            finalPagePermision: "Expense Approval Request",
        },
        {
            name: "Expense Payment List",
            keywords: ['Expense Payment List'],
            permissionName: 'Expense Payment List',
            path: "/payment/paymentList",
            meta: {
                icon: "note_add",
                auth: true,
            },
            component: require("../component/payment/getPaymentList.vue"),
            finalPagePermision: "Expense Payment List",
        },
        
    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/expenseApproval.js